
import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import "../styles/SearchMobileGrid.css";
import {
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import Searchlist from "../../../Component/search/Searchlist";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { addToCart as apiAddToCart, } from "../../ProductDetail/service/productcart.service";
import { persistCartContext, } from "../../Checkout/service/cart.service";
import { getCartCount } from "../../../Component/header/service/CartCount.service";
import { setCartCount } from "../../Cart/redux/cartSlice";
import { getCustomers } from "../../Cart/service/Customers.service";
import {
  Modal,
  Button,
} from "react-bootstrap";

import {
  addToWishlist,
  fetchWishlist,
} from "../../Pages/wishlist/redux/wishlistSlice";

import ModalBoxPopupMobile from "../component/ModalBoxPopupMobile";
import CatalogComponent from "../../../Component/Common/CatalogComponent";
import MobileFilterPdp from "../../../Component/Layout/MobileFilter/MobileFilterPdp";
import { getSearchProductDetails } from "../../Search/service/productdetails.service";


function SearchMobileGridPage() {

const dispatch = useDispatch();
const { slug } = useParams();
const navigate = useNavigate();
const [searchParams] = useSearchParams();
const includeComingSoon = Number(searchParams.get("includeComingSoon") || 0);
const source = searchParams.get("source") || 'quality';
const p_quality_slug = searchParams.get("sourceQuery") || null;
const p_search_text = searchParams.get("q") || null;

  // =====================================================
  // PRODUCT STATES
  // =====================================================

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSize, setSelectedSize] = useState({});
  const [qty, setQty] = useState({});
  const [customQty, setCustomQty] = useState({});
  const [qtyChanged, setQtyChanged] = useState({});
  const [cartActive, setCartActive] = useState({});
  const [wishlistActive, setWishlistActive] = useState({});
  const [addingCartId, setAddingCartId] = useState(null);

  // =====================================================
  // FILTER STATES
  // SAME AS PRODUCT DETAILS
  // =====================================================

  const [selectedFilters, setSelectedFilters] = useState({
    design: [],
    shade: [],
    size: [],
    shape: [],
    price: "",
  });

  // =====================================================
  // CUSTOMER STATES
  // =====================================================

  const [
    selectedCustomer,
    setSelectedCustomer,
  ] = useState(null);

  const [
    showCustomerModal,
    setShowCustomerModal,
  ] = useState(false);

  const [customers, setCustomers] = useState([]);

  const [
    filteredCustomers,
    setFilteredCustomers,
  ] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerLoading, setCustomerLoading] = useState(false);
  // =====================================================
  // PRODUCT SEARCH
  // =====================================================
  const [productSearch, setProductSearch] = useState("");
  // =====================================================
  // SELECTED PRODUCT
  // =====================================================
  const [selectedProduct, setSelectedProduct] = useState(null);

  // =====================================================
  // DETAIL MODAL
  // =====================================================
  const [
    detailModalShow,
    setDetailModalShow,
  ] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  // =====================================================
  // QUALITY
  // =====================================================
  const qualityName =
    products.length > 0
      ? products[0]?.quality_name || ""
      : "";

  // =====================================================
  // DESKTOP REDIRECT
  // =====================================================
useEffect(() => {
  const checkDevice = () => {
    if (window.innerWidth > 768 && p_search_text) {
      navigate(
        `/search?q=${encodeURIComponent(
          p_search_text
        )}&sourceQuery=${encodeURIComponent(p_quality_slug)}`,
        {
          replace: true,
        }
      );
    }
  };

  window.addEventListener("resize", checkDevice);
  return () => {
    window.removeEventListener("resize", checkDevice);
  };
}, [p_search_text, p_quality_slug, slug, navigate]);

  // =====================================================
  // LOAD PRODUCTS
  // =====================================================
useEffect(() => {
  if (!p_search_text) {
    setProducts([]);
    setSelectedSize({});
    setQty({});
    setCustomQty({});
    setQtyChanged({});
    setCartActive({});
    setWishlistActive({});
    return;
  }

  let isActive = true;

  const loadProducts = async () => {
    setLoading(true);

    try {
      const res = await getSearchProductDetails(
        p_quality_slug,
        p_search_text,
        source,
        includeComingSoon
      );
      if (!isActive) return;
      const productData = Array.isArray(res) ? res : [];

      const sizeMap = {};
      const qtyMap = {};

      for (const product of productData) {
        const firstSize = product?.sizes?.[0];

        if (!firstSize) continue;

        const productId = Number(product.product_id);
        const listingId = Number(firstSize.product_id);

        if (!productId || !listingId) continue;

        sizeMap[productId] = listingId;
        qtyMap[listingId] = 0;
      }

      setProducts(productData);
      setSelectedSize(sizeMap);
      setQty(qtyMap);

      // Reset UI state for the new product list
      setCustomQty({});
      setQtyChanged({});
      setCartActive({});
      setWishlistActive({});
    } catch (error) {
      if (!isActive) return;

      console.error("Product API Error =>", error);

      setProducts([]);
      setSelectedSize({});
      setQty({});
      setCustomQty({});
      setQtyChanged({});
      setCartActive({});
      setWishlistActive({});
    } finally {
      if (isActive) {
        setLoading(false);
      }
    }
  };

  loadProducts();

  return () => {
    isActive = false;
  };
}, [
  p_quality_slug,
  p_search_text,
  source,
  includeComingSoon,
]);

  // =====================================================
  // LOAD CUSTOMERS
  // =====================================================

  const loadCustomers = async (
    search = ""
  ) => {
    setCustomerLoading(true);

    try {
      const data =
        await getCustomers(
          search.trim()
        );

      const customerData =
        Array.isArray(data)
          ? data
          : [];

      setCustomers(customerData);

      setFilteredCustomers(
        customerData
      );
    } catch (error) {
      console.error(
        "Customer API Error =>",
        error
      );

      setCustomers([]);
      setFilteredCustomers([]);
    } finally {
      setCustomerLoading(false);
    }
  };

  // =====================================================
  // INITIAL CUSTOMER API
  // =====================================================

  useEffect(() => {
    loadCustomers("");
  }, []);

  // =====================================================
  // CUSTOMER SEARCH DEBOUNCE
  // =====================================================

  useEffect(() => {
    if (!showCustomerModal) {
      return;
    }
    const timer = setTimeout(() => {
      loadCustomers(customerSearch);
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [
    customerSearch,
    showCustomerModal,
  ]);

  // =====================================================
  // GET CUSTOMER ID
  // =====================================================
  const getCustomerId = (customer) => {
    return Number(
      customer?.id ||
        customer?.customer_id ||
        customer?.customerId ||
        0
    );
  };

  // =====================================================
  // PRODUCT IMAGE
  // =====================================================

  const handleProductImageClick = (
    product
  ) => {
    if (!product) {
      return;
    }
    setSelectedProduct(product);
    const image =
      product?.image ||
      product?.image_url ||
      product?.thumbnail ||
      product?.image_path ||
      "";
    setCurrentImage(image);
    setDetailModalShow(true);
  };

  // =====================================================
  // CLOSE DETAIL MODAL
  // =====================================================

  const handleDetailModalClose = () => {
    setDetailModalShow(false);
    setSelectedProduct(null);
    setCurrentImage("");
  };

  // =====================================================
  // OPEN CUSTOMER MODAL
  // =====================================================

  const openCustomerModal = () => {
    setCustomerSearch("");
    setActiveIndex(-1);

    loadCustomers("");

    setShowCustomerModal(true);
  };
  // =====================================================
  // CLOSE CUSTOMER MODAL
  // =====================================================
  const handleCloseModal = () => {
    setShowCustomerModal(false);
    setCustomerSearch("");
    setActiveIndex(-1);
    setFilteredCustomers(customers);
    setSelectedProduct(null);
    setAddingCartId(null);
  };
  // =====================================================
  // NORMAL QUANTITY CHANGE
  // =====================================================

  const handleQuantityChange = (
    listingId,
    value,
    availableStock
  ) => {
    const id = Number(listingId);

    const stock = Number(
      availableStock ?? 0
    );

    if (!id) {
      return;
    }

    if (value === "") {
      setQty((previous) => ({
        ...previous,
        [id]: "",
      }));

      if (cartActive[id]) {
        setQtyChanged((previous) => ({
          ...previous,
          [id]: true,
        }));
      }

      return;
    }

    const newValue = Number(value);

    if (
      !Number.isFinite(newValue) ||
      newValue < 0
    ) {
      return;
    }

    if (newValue > stock) {
      toast.error(
        `Only ${stock} stock available`
      );

      return;
    }

    setQty((previous) => ({
      ...previous,
      [id]: newValue,
    }));

    if (cartActive[id]) {
      setQtyChanged((previous) => ({
        ...previous,
        [id]: true,
      }));
    }
  };

  // =====================================================
  // CUSTOM 10+ QUANTITY
  // =====================================================

  const handleCustomQuantityChange = (
    listingId,
    value
  ) => {
    const id = Number(listingId);

    if (!id) {
      return;
    }

    if (value === "") {
      setQty((previous) => ({
        ...previous,
        [id]: "",
      }));

      if (cartActive[id]) {
        setQtyChanged((previous) => ({
          ...previous,
          [id]: true,
        }));
      }

      return;
    }

    if (!/^\d+$/.test(value)) {
      return;
    }

    const newQty = Number(value);

    if (newQty <= 0) {
      return;
    }

    setQty((previous) => ({
      ...previous,
      [id]: newQty,
    }));

    if (cartActive[id]) {
      setQtyChanged((previous) => ({
        ...previous,
        [id]: true,
      }));
    }
  };

  // =====================================================
  // ADD / UPDATE CART
  // =====================================================

  const handleAddToCart = async (
    selectedSizeData,
    product,
    selectedQuantity = null
  ) => {
    if (!selectedSizeData) {
      toast.error("Please select size");
      return;
    }

    const listingId = Number(
      selectedSizeData.product_id
    );

    const stock = Number(
      selectedSizeData.avail_stock ?? 0
    );

    const quantity =
      selectedQuantity !== null
        ? Number(selectedQuantity)
        : Number(qty[listingId] ?? 0);

    if (!listingId) {
      toast.error(
        "Product ID not found"
      );
      return;
    }

    if (stock <= 0) {
      toast.error(
        "Stock not available"
      );
      return;
    }

    if (
      !Number.isFinite(quantity) ||
      quantity <= 0
    ) {
      toast.error(
        "Please select quantity"
      );
      return;
    }

    if (quantity > stock) {
      toast.error(
        `Only ${stock} stock available`
      );
      return;
    }

    if (addingCartId === listingId) {
      return;
    }

    setQty((previous) => ({
      ...previous,
      [listingId]: quantity,
    }));

    const productData = {
      ...product,
      selectedListing:
        selectedSizeData,
    };

    setSelectedProduct(productData);
    setAddingCartId(listingId);

    try {
      const countResponse =
        await getCartCount(
          "fresh",
          1,
          null
        );

      console.log(
        "CART COUNT RESPONSE =>",
        countResponse
      );

      const responseData =
        countResponse?.data ??
        countResponse ??
        {};

      const cartCount = Number(
        responseData?.count ??
          responseData?.total ??
          responseData?.cart_count ??
          responseData?.cartCount ??
          0
      );

      const cartCustomerId = Number(
        responseData?.customer_id ??
          responseData?.customerId ??
          responseData?.user_customer_id ??
          0
      );

      console.log(
        "CART COUNT =>",
        cartCount
      );

      console.log(
        "CART CUSTOMER ID =>",
        cartCustomerId
      );

      if (cartCount > 0) {
        if (!cartCustomerId) {
          toast.error(
            "Customer ID not found in cart"
          );
          return;
        }

        const existingCustomer = {
          id: cartCustomerId,
          customer_id: cartCustomerId,
        };

        setSelectedCustomer(
          existingCustomer
        );

        await handleCustomerSelect(
          existingCustomer,
          productData,
          quantity
        );

        return;
      }

      if (cartCount === 0) {
        setSelectedProduct(productData);

        setCustomerSearch("");
        setActiveIndex(-1);

        setShowCustomerModal(true);

        await loadCustomers("");

        return;
      }

      toast.error(
        "Unable to check cart"
      );
    } catch (error) {
      console.error(
        "Cart Check Error =>",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to check cart"
      );
    } finally {
      setAddingCartId(null);
    }
  };

  // =====================================================
  // CUSTOMER SELECT
  // =====================================================

  const handleCustomerSelect = async (
    customer,
    productData = selectedProduct,
    selectedQuantity = null
  ) => {
    try {
      if (!productData) {
        toast.error(
          "No product selected"
        );

        return;
      }

      const customerId =
        getCustomerId(customer);

      if (!customerId) {
        toast.error(
          "Customer ID not found"
        );

        console.error(
          "Invalid Customer =>",
          customer
        );

        return;
      }

      const currentCustomer = {
        ...customer,
        id: customerId,
        customer_id: customerId,
      };

      setSelectedCustomer(
        currentCustomer
      );

      const selectedListing =
        productData.selectedListing ||
        productData.sizes?.find(
          (size) =>
            Number(size.product_id) ===
            Number(
              selectedSize[
                productData.product_id
              ]
            )
        ) ||
        productData.sizes?.[0];

      if (!selectedListing) {
        toast.error(
          "Selected size not found"
        );

        return;
      }

      const productId = Number(
        selectedListing.product_id
      );

      const availableStock = Number(
        selectedListing.avail_stock ?? 0
      );

      const quantity =
        selectedQuantity !== null
          ? Number(selectedQuantity)
          : Number(qty[productId] ?? 0);

      if (!productId) {
        toast.error(
          "Product ID not found"
        );

        return;
      }

      if (availableStock <= 0) {
        toast.error(
          "Stock not available"
        );

        return;
      }

      if (
        !Number.isFinite(quantity) ||
        quantity <= 0
      ) {
        toast.error(
          "Please select quantity"
        );

        return;
      }

      if (
        quantity > availableStock
      ) {
        toast.error(
          `Only ${availableStock} stock available`
        );

        return;
      }

      setAddingCartId(productId);

      const payload = {
        cart_type: "fresh",
        user_id: 1,
        customer_id: customerId,
        product_listing_id: productId,
        qty: quantity,
      };

      console.log(
        "Cart Payload =>",
        payload
      );

      const response =
        await apiAddToCart(payload);

      console.log(
        "Cart Response =>",
        response
      );

      if (!response?.success) {
        toast.error(
          response?.message ||
            "Cart update failed"
        );

        return;
      }

      persistCartContext({
        cartType: "fresh",
        userId: 1,
        customerId: customerId,
      });

      try {
        const countResponse =
          await getCartCount(
            "fresh",
            1,
            customerId
          );

        const updatedCount = Number(
          countResponse?.data?.count ??
            countResponse?.count ??
            countResponse?.total ??
            0
        );

        dispatch(
          setCartCount(
            updatedCount
          )
        );
      } catch (countError) {
        console.error(
          "Cart Count Error =>",
          countError
        );
      }

      setCartActive(
        (previous) => ({
          ...previous,
          [productId]: true,
        })
      );

      setQtyChanged(
        (previous) => ({
          ...previous,
          [productId]: false,
        })
      );

      toast.success(
        "Cart updated successfully"
      );

      setShowCustomerModal(false);
      setSelectedProduct(null);

      setCustomerSearch("");
      setActiveIndex(-1);
    } catch (error) {
      console.error(
        "Add Cart Error =>",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong"
      );
    } finally {
      setAddingCartId(null);
    }
  };

  // =====================================================
  // APPLY FILTER
  // SAME LOGIC AS PRODUCT DETAILS
  // =====================================================

  const handleApplyFilters = (
    filters
  ) => {
    setSelectedFilters({
      design: Array.isArray(
        filters?.design
      )
        ? filters.design
        : [],

      shade: Array.isArray(
        filters?.shade
      )
        ? filters.shade
        : [],

      size: Array.isArray(
        filters?.size
      )
        ? filters.size
        : [],

      shape: Array.isArray(
        filters?.shape
      )
        ? filters.shape
        : [],

      price:
        filters?.price || "",
    });
  };

  // =====================================================
  // CLEAR FILTER
  // =====================================================

  const handleClearFilters = () => {
    setSelectedFilters({
      design: [],
      shade: [],
      size: [],
      shape: [],
      price: "",
    });
  };

  // =====================================================
  // PRICE MATCH
  // =====================================================

  const priceMatches = (
    mrp,
    priceFilter
  ) => {
    const price = Number(mrp);

    if (Number.isNaN(price)) {
      return false;
    }

    if (!priceFilter) {
      return true;
    }

    if (
      priceFilter.endsWith("+")
    ) {
      const minimum = Number(
        priceFilter.replace("+", "")
      );

      return price >= minimum;
    }

    const parts =
      priceFilter.split("-");

    if (parts.length === 2) {
      const minimum = Number(
        parts[0]
      );

      const maximum = Number(
        parts[1]
      );

      return (
        price >= minimum &&
        price <= maximum
      );
    }

    return false;
  };

  // =====================================================
  // FILTER PRODUCTS
  // SEARCH + DESIGN + SHADE + SIZE + SHAPE + PRICE
  // =====================================================

  const filteredProducts = useMemo(() => {
    const keyword =
      productSearch
        .trim()
        .toLowerCase();

    return products
      .map((item) => {

        // =================================================
        // SEARCH
        // =================================================

        if (keyword) {
          const design =
            String(
              item?.design || ""
            ).toLowerCase();

          const shade =
            String(
              item?.shade || ""
            ).toLowerCase();

          const designShade =
            String(
              item?.designshade || ""
            ).toLowerCase();

          const matched =
            design.includes(keyword) ||
            shade.includes(keyword) ||
            designShade.includes(keyword);

          if (!matched) {
            return null;
          }
        }

        // =================================================
        // DESIGN FILTER
        // =================================================

        if (
          selectedFilters.design
            .length > 0 &&
          !selectedFilters.design.includes(
            item?.design
          )
        ) {
          return null;
        }

        // =================================================
        // SHADE FILTER
        // =================================================

        if (
          selectedFilters.shade
            .length > 0 &&
          !selectedFilters.shade.includes(
            item?.shade
          )
        ) {
          return null;
        }

        // =================================================
        // ORIGINAL SIZES
        // =================================================

        const sizes =
          Array.isArray(item?.sizes)
            ? item.sizes
            : [];

        // =================================================
        // FILTER SIZES
        // =================================================

        const filteredSizes =
          sizes.filter(
            (sizeItem) => {

              // SIZE
              if (
                selectedFilters.size
                  .length > 0 &&
                !selectedFilters.size.includes(
                  sizeItem?.size
                )
              ) {
                return false;
              }

              // SHAPE
              if (
                selectedFilters.shape
                  .length > 0 &&
                !selectedFilters.shape.includes(
                  sizeItem?.shape
                )
              ) {
                return false;
              }

              // PRICE
              if (
                selectedFilters.price &&
                !priceMatches(
                  sizeItem?.mrp,
                  selectedFilters.price
                )
              ) {
                return false;
              }

              return true;
            }
          );

        // =================================================
        // CHECK SIZE LEVEL FILTER
        // =================================================

        const isSizeFilterApplied =
          selectedFilters.size
            .length > 0;

        const isShapeFilterApplied =
          selectedFilters.shape
            .length > 0;

        const isPriceFilterApplied =
          Boolean(
            selectedFilters.price
          );

        const isSizeLevelFilterApplied =
          isSizeFilterApplied ||
          isShapeFilterApplied ||
          isPriceFilterApplied;

        if (
          isSizeLevelFilterApplied &&
          filteredSizes.length === 0
        ) {
          return null;
        }

        // =================================================
        // RETURN FILTERED PRODUCT
        // =================================================

        return {
          ...item,
          sizes: filteredSizes,
        };
      })
      .filter(Boolean);
  }, [
    products,
    productSearch,
    selectedFilters,
  ]);

  // =====================================================
  // WISHLIST
  // =====================================================

  const handleAddWishlist = async (
    product
  ) => {
    try {
      const selectedListing =
        product.sizes?.find(
          (size) =>
            Number(size.product_id) ===
            Number(
              selectedSize[
                product.product_id
              ]
            )
        ) ||
        product.sizes?.[0];

      if (
        !selectedListing?.product_id
      ) {
        toast.error(
          "Product ID not found"
        );

        return;
      }

      const productId = Number(
        selectedListing.product_id
      );

      const payload = {
        user_id: 1,
        product_listing_id: productId,
      };

      console.log(
        "Wishlist Payload =>",
        payload
      );

      const response =
        await dispatch(
          addToWishlist(payload)
        ).unwrap();

      if (!response?.success) {
        toast.error(
          response?.message ||
            "Failed to add wishlist"
        );

        return;
      }

      setWishlistActive(
        (previous) => ({
          ...previous,
          [productId]: true,
        })
      );

      await dispatch(
        fetchWishlist({
          userId: 1,
          customerId: null,
        })
      );

      toast.success(
        "Added to Wishlist"
      );
    } catch (error) {
      console.error(
        "Wishlist Error =>",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong"
      );
    }
  };

  // =====================================================
  // HIGHLIGHT CUSTOMER SEARCH
  // =====================================================

  const highlightText = (
    text = "",
    searchValue = ""
  ) => {
    const searchText =
      searchValue.trim();

    if (
      searchText.length < 1
    ) {
      return text;
    }

    const escaped =
      searchText.replace(
        /[.*+?^${}()|[\]\\]/g,
        "\\$&"
      );

    const regex = new RegExp(
      `(${escaped})`,
      "gi"
    );

    return String(text)
      .split(regex)
      .map(
        (
          part,
          index
        ) =>
          part.toLowerCase() ===
          searchText.toLowerCase() ? (
            <span
              key={index}
              style={{
                fontWeight: "700",
                color: "#000",
              }}
            >
              {part}
            </span>
          ) : (
            part
          )
      );
  };

  // =====================================================
  // BREADCRUMB
  // =====================================================

  const breadcrumbProduct =
    products?.[0];

  const breadcrumbItems =
    breadcrumbProduct
      ? [
          {
            name:"Search",
            path:"#",
          },
          {
            name:p_search_text,
            path: "#",
          },
        ]
      : [];

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <>
      <Toaster position="top-right"  />
      <Breadcrumb items={breadcrumbItems}
      />
      <div
        className="grid-container-List"
        style={{
          background: "#e5e5e5",
        }}
      >
        <div className="container mt-3">

          {/* =================================================
              HEADER
          ================================================= */}

          <div className="row align-items-center">

            <div className="col-md-9">
              <p
                style={{
                  marginTop: "10px",
                }}
              >
                Showing{" "}
                {
                  filteredProducts.length
                }{" "}
                designs{" "}
                {qualityName && (
                  <>
                    in "
                    <strong>
                      {qualityName}
                    </strong>
                    "
                  </>
                )}
              </p>
            </div>

            <div className="col-md-3">
               <div className="search-filter-row">

                {/* SEARCH */}

                <Searchlist
                  value={
                    productSearch
                  }
                  onChange={(e) =>
                    setProductSearch(
                      e.target.value
                    )
                  }
                />

                {/* FILTER */}

                <MobileFilterPdp
                  products={products}
                  selectedFilters={
                    selectedFilters
                  }
                  onApplyFilters={
                    handleApplyFilters
                  }
                  onClearFilters={
                    handleClearFilters
                  }
                />

              </div>
            </div>
          </div>

          {/* =================================================
              ACTIVE FILTER INFO
          ================================================= */}

          {(selectedFilters.design.length > 0 ||
            selectedFilters.shade.length > 0 ||
            selectedFilters.size.length > 0 ||
            selectedFilters.shape.length > 0 ||
            selectedFilters.price) && (
            <div
              className="mb-2"
              style={{
                fontSize: "12px",
                color: "#666",
              }}
            >
              Filters applied
            </div>
          )}

          {/* =================================================
              PRODUCTS
          ================================================= */}

          <div className="row gutters-3">

            <div className="col-12">

              <div
                className="card product-list-card border-0 shadow-sm"
                style={{
                  background: "#e5e5e5",
                }}
              >

                <div className="card-body p-2">

                  <div className="list-group list-group-flush">

                    {/* LOADING */}

                    {loading ? (
                      Array.from({
                        length: 6,
                      }).map(
                        (_, index) => (
                          <Skeleton
                            key={index}
                            height={170}
                          />
                        )
                      )
                    ) : filteredProducts.length ===
                      0 ? (

                      <li className="list-group-item text-center">
                        No products found
                      </li>

                    ) : (

                      filteredProducts.map(
                        (product) => {

                          // =================================================
                          // SELECTED SIZE
                          // =================================================

                          const selected =
                            product.sizes?.find(
                              (size) =>
                                Number(
                                  size.product_id
                                ) ===
                                Number(
                                  selectedSize[
                                    product.product_id
                                  ]
                                )
                            ) ||
                            product.sizes?.[0];

                          // =================================================
                          // LISTING ID
                          // =================================================

                          const listingId =
                            Number(
                              selected?.product_id ||
                                0
                            );

                          // =================================================
                          // STOCK
                          // =================================================

                          const stock =
                            Number(
                              selected?.avail_stock ??
                                0
                            );

                          // =================================================
                          // QUANTITY
                          // =================================================

                          const rawQty =
                            qty[listingId];

                          const currentQty =
                            rawQty === ""
                              ? ""
                              : Number(
                                  rawQty ?? 0
                                );

                          const numericQty =
                            Number(
                              currentQty
                            );

                          const hasValidQty =
                            stock > 0 &&
                            Number.isFinite(
                              numericQty
                            ) &&
                            numericQty > 0;

                          // =================================================
                          // CART STATE
                          // =================================================

                          const isCartLoading =
                            addingCartId ===
                            listingId;

                          const isCartActive =
                            Boolean(
                              cartActive[
                                listingId
                              ]
                            );

                          const isQtyChanged =
                            Boolean(
                              qtyChanged[
                                listingId
                              ]
                            );

                          // =================================================
                          // WISHLIST
                          // =================================================

                          const isWishlistActive =
                            Boolean(
                              wishlistActive[
                                listingId
                              ]
                            );

                          return (
                            <div
                              className="product-list-item row g-0"
                              key={
                                product.design
                              }
                            >

                              {/* IMAGE */}

                              <div className="col-3">

                                <div className="media">

                                  <div
                                    className="media-img"
                                    onClick={() =>
                                      handleProductImageClick(
                                        product
                                      )
                                    }
                                    style={{
                                      cursor:
                                        "pointer",
                                    }}
                                  >

                                    {product?.image ||
                                    product?.image_url ||
                                    product?.thumbnail ||
                                    product?.image_path ? (

                                      <img
                                        src={
                                          product?.image ||
                                          product?.image_url ||
                                          product?.thumbnail ||
                                          product?.image_path
                                        }
                                        alt={
                                          product?.name ||
                                          product?.designshade ||
                                          "Product"
                                        }
                                        className="img-fluid"
                                      />

                                    ) : (

                                      <div
                                        className="bg-light"
                                        style={{
                                          width: 80,
                                          height: 80,
                                        }}
                                      />

                                    )}

                                  </div>

                                </div>

                              </div>

                              {/* PRODUCT DATA */}

                              <div
                                className="col-9"
                                style={{
                                  paddingLeft:
                                    "0",
                                }}
                              >

                                <div className="product-action-row">

                                  <div className="media-body">

                                    {/* NAME */}

                                    <p className="mb-0">

                                      <span>
                                        {
                                          product.designshade
                                        }
                                      </span>

                                      {/* WISHLIST */}

                                      <button
                                        type="button"
                                        className={`btn btn-icon rounded-circle btn-wishlist ${
                                          isWishlistActive
                                            ? "wishlist-active"
                                            : "btn-text-danger"
                                        }`}
                                        onClick={() =>
                                          handleAddWishlist(
                                            product
                                          )
                                        }
                                      >

                                        <i
                                          className={
                                            isWishlistActive
                                              ? "bi bi-heart-fill"
                                              : "bi bi-heart"
                                          }
                                        />

                                      </button>

                                    </p>

                                    {/* SHAPE / STOCK */}

                                    <div className="row">

                                      <div className="col-12">

                                        <div className="d-flex">

                                          <span>
                                            {
                                              selected?.shape ||
                                              "-"
                                            }
                                          </span>

                                          <div className="stock-info">

                                            <strong>
                                              Stock :
                                            </strong>{" "}

                                            {
                                              selected?.avail_stock ??
                                              0
                                            }

                                          </div>

                                        </div>

                                      </div>

                                    </div>

                                    {/* PRICE / SIZE / QTY / CART */}

                                    <div className="font-size-sm mt-2 product-controls">

                                      {/* PRICE */}

                                      <div className="price">

                                        <i className="bi bi-currency-rupee" />

                                        {
                                          selected?.mrp ??
                                          0
                                        }

                                      </div>

                                      {/* SIZE */}

                                      <select
                                        className="form-control form-control-sm size-select text-center"
                                        value={
                                          selectedSize[
                                            product.product_id
                                          ] || ""
                                        }
                                        disabled={
                                          isCartLoading
                                        }
                                        onChange={(
                                          e
                                        ) => {

                                          const newListingId =
                                            Number(
                                              e
                                                .target
                                                .value
                                            );

                                          setSelectedSize(
                                            (
                                              previous
                                            ) => ({
                                              ...previous,
                                              [product.product_id]:
                                                newListingId,
                                            })
                                          );

                                          setQty(
                                            (
                                              previous
                                            ) => ({
                                              ...previous,
                                              [newListingId]:
                                                previous[
                                                  newListingId
                                                ] ??
                                                0,
                                            })
                                          );

                                          setCustomQty(
                                            (
                                              previous
                                            ) => ({
                                              ...previous,
                                              [newListingId]:
                                                false,
                                            })
                                          );

                                          setQtyChanged(
                                            (
                                              previous
                                            ) => ({
                                              ...previous,
                                              [newListingId]:
                                                false,
                                            })
                                          );
                                        }}
                                      >

                                        {product.sizes?.map(
                                          (
                                            size
                                          ) => (
                                            <option
                                              key={
                                                size.product_id
                                              }
                                              value={
                                                size.product_id
                                              }
                                            >
                                              {
                                                size.size
                                              }
                                            </option>
                                          )
                                        )}

                                      </select>

                                      {/* QUANTITY */}

                                      <div
                                        className="quantity-select-wrapper"
                                        style={{
                                          width:
                                            "75px",
                                        }}
                                      >

                                        {customQty[
                                          listingId
                                        ] ? (

                                          <input
                                            type="text"
                                            inputMode="numeric"
                                            className="form-control form-control-sm text-center select-List"
                                            value={
                                              currentQty ===
                                              ""
                                                ? ""
                                                : currentQty
                                            }
                                            autoFocus
                                            disabled={
                                              isCartLoading
                                            }
                                            style={{
                                              width:
                                                "100%",
                                              fontSize:
                                                "13px",
                                            }}
                                            onFocus={(
                                              e
                                            ) => {
                                              e.target.select();
                                            }}
                                            onChange={(
                                              e
                                            ) => {
                                              handleCustomQuantityChange(
                                                listingId,
                                                e
                                                  .target
                                                  .value
                                              );
                                            }}
                                            onKeyDown={(
                                              e
                                            ) => {

                                              if (
                                                e.key ===
                                                "Enter"
                                              ) {
                                                e.preventDefault();
                                                e.target.blur();
                                              }

                                            }}
                                          />

                                        ) : (

                                          <select
                                            className="form-control form-control-sm text-center select-List"
                                            value={
                                              currentQty ===
                                              ""
                                                ? ""
                                                : currentQty
                                            }
                                            disabled={
                                              isCartLoading ||
                                              stock <=
                                                0
                                            }
                                            style={{
                                              width:
                                                "100%",
                                              fontSize:
                                                "13px",
                                            }}
                                            onChange={(
                                              e
                                            ) => {

                                              const value =
                                                e
                                                  .target
                                                  .value;

                                              // 10+

                                              if (
                                                value ===
                                                "10+"
                                              ) {

                                                setCustomQty(
                                                  (
                                                    previous
                                                  ) => ({
                                                    ...previous,
                                                    [listingId]:
                                                      true,
                                                  })
                                                );

                                                setQty(
                                                  (
                                                    previous
                                                  ) => ({
                                                    ...previous,
                                                    [listingId]:
                                                      10,
                                                  })
                                                );

                                                return;
                                              }

                                              const newQty =
                                                Number(
                                                  value
                                                );

                                              // 0

                                              if (
                                                newQty ===
                                                0
                                              ) {

                                                handleQuantityChange(
                                                  listingId,
                                                  value,
                                                  stock
                                                );

                                                return;
                                              }

                                              // 1 - 9

                                              if (
                                                newQty >=
                                                  1 &&
                                                newQty <=
                                                  9
                                              ) {

                                                handleQuantityChange(
                                                  listingId,
                                                  value,
                                                  stock
                                                );

                                                handleAddToCart(
                                                  selected,
                                                  product,
                                                  newQty
                                                );
                                              }

                                            }}
                                          >

                                            <option value="0">
                                              0
                                            </option>

                                            {Array.from(
                                              {
                                                length:
                                                  Math.min(
                                                    9,
                                                    stock
                                                  ),
                                              },
                                              (
                                                _,
                                                index
                                              ) =>
                                                index +
                                                1
                                            ).map(
                                              (
                                                qtyValue
                                              ) => (
                                                <option
                                                  key={
                                                    qtyValue
                                                  }
                                                  value={
                                                    qtyValue
                                                  }
                                                >
                                                  {
                                                    qtyValue
                                                  }
                                                </option>
                                              )
                                            )}

                                            {stock >=
                                              10 && (
                                              <option value="10+">
                                                10+
                                              </option>
                                            )}

                                          </select>

                                        )}

                                      </div>

                                      {/* CART BUTTON */}

                                      <div className="action-buttons">

                                        <button
                                          type="button"
                                          className={`btn btn-md has-icon addtocart ${
                                            isCartActive &&
                                            !isQtyChanged
                                              ? "cart-active"
                                              : "btn-outline-secondary"
                                          }`}
                                          onClick={() =>
                                            handleAddToCart(
                                              selected,
                                              product
                                            )
                                          }
                                          disabled={
                                            isCartLoading ||
                                            stock <=
                                              0 ||
                                            !hasValidQty
                                          }
                                          title={
                                            stock <=
                                            0
                                              ? "Stock not available"
                                              : !hasValidQty
                                              ? "Enter valid quantity"
                                              : isCartActive &&
                                                isQtyChanged
                                              ? "Update quantity"
                                              : isCartActive
                                              ? "Already in cart"
                                              : "Add to cart"
                                          }
                                        >

                                          {isCartLoading ? (

                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            />

                                          ) : isCartActive &&
                                            isQtyChanged ? (

                                            <i className="bi bi-arrow-repeat" />

                                          ) : isCartActive ? (

                                            <i className="bi bi-cart-check-fill" />

                                          ) : (

                                            <i className="bi bi-cart-plus" />

                                          )}

                                        </button>

                                      </div>

                                    </div>

                                  </div>

                                </div>

                              </div>

                            </div>
                          );
                        }
                      )
                    )}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </div>

      {/* =====================================================
          CUSTOMER MODAL
      ===================================================== */}

      <Modal
        show={
          showCustomerModal
        }
        onHide={
          handleCloseModal
        }
        backdrop={true}
        keyboard={true}
        centered={false}
        restoreFocus={false}
        dialogClassName="customer-modal-dialog"
        contentClassName="customer-modal-content"
      >

        <Modal.Body className="p-0">

          <div className="position-relative serchlistdata pt-2">

            <input
              type="search"
              className="form-control"
              placeholder="Search Customer..."
              autoFocus
              value={
                customerSearch
              }
              style={{
                borderRadius:
                  "5px",
                fontSize:
                  "13px",
                height:
                  "30px",
                marginTop:
                  "20%",
                width:
                  "75%",
              }}
              onChange={(e) => {

                const value =
                  e.target.value;

                setCustomerSearch(
                  value
                );

                setActiveIndex(
                  -1
                );
              }}
              onKeyDown={(e) => {

                if (
                  e.key ===
                  "ArrowDown"
                ) {

                  e.preventDefault();

                  setActiveIndex(
                    (previous) =>
                      previous <
                      filteredCustomers.length -
                        1
                        ? previous + 1
                        : previous
                  );

                  return;
                }

                if (
                  e.key ===
                  "ArrowUp"
                ) {

                  e.preventDefault();

                  setActiveIndex(
                    (previous) =>
                      previous >
                      0
                        ? previous - 1
                        : 0
                  );

                  return;
                }

                if (
                  e.key ===
                    "Enter" &&
                  activeIndex >=
                    0
                ) {

                  e.preventDefault();

                  const customer =
                    filteredCustomers[
                      activeIndex
                    ];

                  if (
                    customer
                  ) {

                    handleCustomerSelect(
                      customer
                    );

                  }
                }

              }}
            />

            {/* CUSTOMER LIST */}

            {customerSearch && (

              <div
                className="position-absolute"
                style={{
                  top:
                    "calc(100% - 1px)",
                  left: 0,
                  right: 0,
                  maxHeight:
                    "250px",
                  overflowY:
                    "auto",
                  background:
                    "#fff",
                  border:
                    "1px solid #dee2e6",
                  borderTop:
                    "none",
                  borderRadius:
                    "4px 3px 6px 6px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.15) 0px 15px 12px",
                  zIndex:
                    9999,
                  width:
                    "75%",
                  fontSize:
                    "13px",
                }}
              >

                {customerLoading ? (

                  <div
                    style={{
                      padding:
                        "10px",
                      textAlign:
                        "center",
                    }}
                  >
                    Loading customers...
                  </div>

                ) : filteredCustomers.length >
                  0 ? (

                  filteredCustomers.map(
                    (
                      customer,
                      index
                    ) => (

                      <div
                        key={
                          customer.id ||
                          customer.customer_id ||
                          customer.customerId ||
                          index
                        }
                        onClick={() =>
                          handleCustomerSelect(
                            customer
                          )
                        }
                        onMouseEnter={() =>
                          setActiveIndex(
                            index
                          )
                        }
                        style={{
                          padding:
                            "5px 12px",
                          cursor:
                            "pointer",
                          background:
                            activeIndex ===
                            index
                              ? "#ededed"
                              : "#fff",
                          borderBottom:
                            "1px solid #ddd",
                        }}
                      >

                        {highlightText(
                          customer.accountName ||
                            "",
                          customerSearch
                        )}

                      </div>

                    )
                  )

                ) : (

                  <div
                    style={{
                      padding:
                        10,
                      textAlign:
                        "center",
                    }}
                  >
                    No customer found
                  </div>

                )}

              </div>

            )}

          </div>

        </Modal.Body>

      </Modal>

      {/* =====================================================
          PRODUCT DETAIL MODAL
      ===================================================== */}

      {selectedProduct && (

        <ModalBoxPopupMobile
          Modal={Modal}
          Button={Button}
          detailModalShow={
            detailModalShow
          }
          handleDetailModalClose={
            handleDetailModalClose
          }
          currentImage={
            currentImage
          }
          product={
            selectedProduct
          }
          qualityName={
            qualityName
          }
        />

      )}

      {/* =====================================================
          WHATSAPP / CATALOG
      ===================================================== */}

      <CatalogComponent
        products={
          filteredProducts
        }
        selectedFilters={
          selectedFilters
        }
        search={
          productSearch
        }
      />

    </>
  );
}

export default SearchMobileGridPage;
